import { useEffect, useLayoutEffect } from 'react';
import { isSSR } from '../helper';
export const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;
